<div class="test-notification d-flex align-items-start gap-2">
  <i class="fas fa-vial test-notification__icon notification-item-icon" aria-hidden="true"></i>
  <span class="small">
    {{ 'AgenticCX::Notification:Test:Message' | abpLocalization: sentByUserName }}
  </span>
</div>
